export const MINUTES_PER_MONTH = 30 * 24 * 60;

export const PERSONAL_PLAN_ORDER = ['echo', 'plus', 'pro', 'promax'];

export const DEPLOYMENT_MONTHLY_COST_TOMAN =
  Number(process.env.REACT_APP_DEPLOYMENT_MONTHLY_COST) || 350000;

export const PLATFORM_PRICING_ITEMS = [
  {
    id: 'publishing',
    monthlyToman: 350000,
    icon: 'rocket'
  },
  {
    id: 'userManagement',
    monthlyToman: 25000,
    icon: 'users'
  }
];

export const getPerMinutePrice = (monthlyToman) => monthlyToman / MINUTES_PER_MONTH;

export const resolvePlanAction = (pkg, entitlement) => {
  if (!entitlement?.hasPackage) {
    return { type: 'buy', disabled: false };
  }

  const currentSlug = entitlement.purchasedPackageSlug || entitlement.packageSlug;
  const currentKind = entitlement.packageKind || (entitlement.source === 'Organization' ? 'Organization' : 'Personal');
  if (pkg.kind !== currentKind) {
    return { type: 'disabled', disabled: true };
  }

  if (pkg.slug === currentSlug) {
    return { type: 'current', disabled: true };
  }

  if (pkg.kind === 'Personal') {
    const currentRank = PERSONAL_PLAN_ORDER.indexOf(currentSlug);
    const nextRank = PERSONAL_PLAN_ORDER.indexOf(pkg.slug);
    if (currentRank >= 0 && nextRank > currentRank) {
      return { type: 'upgrade', disabled: false };
    }
    return { type: 'disabled', disabled: true };
  }

  if (Number(pkg.priceToman) > Number(entitlement.priceToman || 0)) {
    return { type: 'upgrade', disabled: false };
  }

  return { type: 'disabled', disabled: true };
};

export const upgradePayableToman = (pkg, entitlement) =>
  Math.max(0, Number(pkg.payableToman || 0) - Number(entitlement?.remainingCreditToman || 0));

export const hasActivePackageDiscount = (pkg) => {
  const percent = Number(pkg?.discountPercent || 0);
  const price = Number(pkg?.priceToman || 0);
  const payable = Number(pkg?.payableToman || 0);
  return percent > 0 && price > payable && payable >= 0;
};

export const formatDiscountPercent = (value) => {
  const percent = Number(value || 0);
  if (!Number.isFinite(percent)) {
    return '0';
  }

  return String(Number.parseFloat(percent.toFixed(2)));
};

